var $ = jQuery;
var $document = $(document);

$(function ($) {
    $('.js-testimonials-carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 10000,
    });
});
